import { useCallback, useEffect, useState } from "react";

import { initializeNativeStore } from "./nativeStore";
import { isNativeApp } from "./runtime";

export default function useNativeStoreCatalog(enabled = true) {
  const nativeApp = isNativeApp();
  const [products, setProducts] = useState([]);
  const [ready, setReady] = useState(!nativeApp || !enabled);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!nativeApp || !enabled) {
      setProducts([]);
      setReady(true);
      setError(null);
      return [];
    }
    setReady(false);
    try {
      const result = await initializeNativeStore();
      const nextProducts = Array.isArray(result?.products) ? result.products : [];
      setProducts(nextProducts);
      setError(null);
      return nextProducts;
    } catch (nextError) {
      setProducts([]);
      setError(nextError);
      return [];
    } finally {
      setReady(true);
    }
  }, [enabled, nativeApp]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { nativeApp, products, ready, error, refresh };
}
